import { HttpApi } from "@effect/platform";
import { authGroup } from "@pima/identity/http";
import { LoginMethodsGate } from "./login-methods-gate.js";
import { WebSignupGate } from "./web-signup-gate.js";
import { catalogueAuthoringGroup } from "./catalogue-authoring.js";
import { adminClientsGroup } from "./admin-clients.js";
import { adminClientAccessGroup } from "./admin-client-access.js";
import { adminLoginDomainsGroup } from "./admin-login-domains.js";
import { adminInspectionsGroup } from "./admin-inspections.js";
import { adminDocumentsGroup } from "./admin-documents.js";
import { adminExaminationsGroup } from "./examinations.js";
import { adminFilesGroup } from "./admin-files.js";
import { adminFoldersGroup } from "./admin-folders.js";
import { adminLocationRiskFieldsGroup } from "./admin-location-risk-fields.js";
import { adminLocationsGroup } from "./admin-locations.js";
import { adminMeasureTemplatesGroup } from "./admin-measure-templates.js";
import { adminQuestionnairesGroup } from "./admin-questionnaires.js";
import { adminRiskActionsGroup } from "./admin-risk-actions.js";
import { adminRiskCatalogValuesGroup } from "./admin-risk-catalog-values.js";
import { adminRiskInstancesGroup } from "./admin-risk-instances.js";
import { adminRiskTemplatesGroup } from "./admin-risk-templates.js";
import { adminOnlineCoursesGroup } from "./online-courses.js";
import { onlineCourseSharesGroup } from "./online-course-shares.js";
import { dashboardFileSharesGroup } from "./dashboard-file-shares.js";
import { adminSettingsGroup } from "./admin-settings.js";
import { adminUsersGroup } from "./admin-users.js";
import { courseMetadataGroup } from "./course-metadata.js";
import { dearestGroup } from "./dearest.js";
import { employeesGroup } from "./employees.js";
import { filesGroup } from "./files.js";
import { foldersGroup } from "./folders.js";
import { hrisGroup } from "./hris.js";
import { invitationsGroup } from "./invitations.js";
import { webSignupGroup, workEmailConfirmationGroup, } from "./work-email-confirmation.js";
import { adminHeldPairsGroup } from "./admin-held-pairs.js";
import { privateEmailConfirmationGroup } from "./private-email.js";
import { measuresGroup } from "./measures.js";
import { insightsGroup } from "./insights.js";
import { notificationsGroup } from "./notifications.js";
import { ownClientGroup } from "./own-client.js";
import { precautionaryIndexGroup } from "./precautionary-index.js";
import { savedSearchesGroup } from "./saved-searches.js";
import { sessionGroup } from "./session.js";
import { sessionTokensGroup } from "./session-tokens.js";
import { adminSharingGroup } from "./sharing.js";
import { sharesGroup } from "./shares.js";
import { reportsGroup } from "./reports.js";
import { authorizedReadsGroup } from "./authorized-reads.js";
// Only browser-facing intents belong in this contract. Service-key operations
// remain on the host contract and its dedicated internal client.
export const webFrontendApi = HttpApi.empty
    .add(catalogueAuthoringGroup.prefix("/v1"))
    .add(authorizedReadsGroup.prefix("/v1"))
    .add(reportsGroup.prefix("/v1"))
    .add(sharesGroup.prefix("/v1"))
    .add(sessionGroup.prefix("/v1"))
    .add(sessionTokensGroup.prefix("/v1"))
    .add(invitationsGroup.prefix("/v1"))
    .add(workEmailConfirmationGroup.prefix("/v1"))
    .add(privateEmailConfirmationGroup.prefix("/v1"))
    // Rate limited per caller address before anything runs: see WebSignupGate.
    .add(webSignupGroup.middleware(WebSignupGate).prefix("/v1"))
    .add(adminHeldPairsGroup.prefix("/v1"))
    // Gated as route middleware, after the router has matched: see LoginMethodsGate.
    .add(authGroup.middleware(LoginMethodsGate).prefix("/v1"))
    .add(ownClientGroup.prefix("/v1"))
    .add(courseMetadataGroup.prefix("/v1"))
    .add(foldersGroup.prefix("/v1"))
    .add(filesGroup.prefix("/v1"))
    .add(notificationsGroup.prefix("/v1"))
    .add(measuresGroup.prefix("/v1"))
    .add(insightsGroup.prefix("/v1"))
    .add(hrisGroup.prefix("/v1"))
    .add(employeesGroup.prefix("/v1"))
    .add(precautionaryIndexGroup.prefix("/v1"))
    .add(dearestGroup.prefix("/v1"))
    .add(adminClientsGroup.prefix("/v1"))
    .add(adminClientAccessGroup.prefix("/v1"))
    .add(adminLoginDomainsGroup.prefix("/v1"))
    .add(adminLocationsGroup.prefix("/v1"))
    .add(adminUsersGroup.prefix("/v1"))
    .add(adminFoldersGroup.prefix("/v1"))
    .add(adminSettingsGroup.prefix("/v1"))
    .add(savedSearchesGroup.prefix("/v1"))
    .add(adminSharingGroup.prefix("/v1"))
    .add(adminOnlineCoursesGroup.prefix("/v1"))
    .add(onlineCourseSharesGroup.prefix("/v1"))
    .add(dashboardFileSharesGroup.prefix("/v1"))
    .add(adminDocumentsGroup.prefix("/v1"))
    .add(adminExaminationsGroup.prefix("/v1"))
    .add(adminFilesGroup.prefix("/v1"))
    .add(adminRiskTemplatesGroup.prefix("/v1"))
    .add(adminRiskInstancesGroup.prefix("/v1"))
    .add(adminLocationRiskFieldsGroup.prefix("/v1"))
    .add(adminRiskActionsGroup.prefix("/v1"))
    .add(adminMeasureTemplatesGroup.prefix("/v1"))
    .add(adminQuestionnairesGroup.prefix("/v1"))
    .add(adminRiskCatalogValuesGroup.prefix("/v1"))
    .add(adminInspectionsGroup.prefix("/v1"));
export { ListClientAuthDomains, CreateClientAuthDomain, } from "./admin-clients.js";
//# sourceMappingURL=frontend-contract.js.map